import usePreference from "./usePreference";

/**
 * Get server info from redux store
 * End point: "/info"
 */
const useServerInfo = () => {
  const { serverInfo } = usePreference();
  return serverInfo;
};

export default useServerInfo;
